import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Tsunami } from './tsunamis/Tsunami';
import { Earthquake } from './earthquakes/Earthquake';
import { Volcano } from './volcanoes/Volcano';

export const Hazards = ({ basePath }) => (
  <Switch>
    <Route path={`${basePath}/tsunami`} render={props => (<Tsunami {...props} basePath={`${basePath}/tsunami`} />)} />
    <Route path={`${basePath}/earthquake`} render={props => (<Earthquake {...props} basePath={`${basePath}/earthquake`} />)} />
    <Route path={`${basePath}/volcano`} render={props => (<Volcano {...props} basePath={`${basePath}/volcano`} />)} />
    <Redirect to="/home" />
  </Switch>
);

Hazards.propTypes = {
  basePath: PropTypes.string.isRequired,
};
